import { ChevronRight, Medal } from "lucide-react";

export const MobileTeamCard = ({
    team,
    index,
    itemsRef,
    navigate,
    }: {
    team: any;
    index: number;
    itemsRef: any;
    navigate: any;
}) => {
  return (
    <div
      key={team.teamId}
      ref={(el) => {
        if (el) itemsRef.current[team.teamId] = el;
      }}
      className={`leaderboard-card bg-white dark:bg-gray-800 rounded-lg shadow p-4 cursor-pointer transition-colors duration-200`}
      onClick={() => {
        const currentPath = window.location.pathname;
        if (currentPath.startsWith("/currentSeason")) {
          navigate(`/currentSeason/leaderboard/team/${team.teamId}`);
        } else {
          navigate(`/leaderboard/team/${team.teamId}`);
        }
      }}
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-3">
          {team.teamLogo && (
            <img
              src={`/api/static/images/${team.teamLogo}`}
              alt={team.teamName}
              className="w-12 h-12 rounded-full"
            />
          )}
          <div>
            <div className="font-medium text-gray-900 dark:text-white">
              {team.teamName}
            </div>
            <div className="text-sm text-gray-500 dark:text-gray-400">
              Top 6 Players Total
            </div>
          </div>
        </div>
        <div className="flex items-center">
          {index < 3 && (
            <Medal
              className={`w-5 h-5 mr-2 ${
                index === 0
                  ? "text-yellow-400"
                  : index === 1
                  ? "text-gray-400"
                  : "text-amber-600"
              }`}
            />
          )}
          <span className="text-lg font-semibold text-gray-900 dark:text-white">
            {team.totalScore}
          </span>
        </div>
      </div>
      <div className="flex justify-between items-center text-sm text-gray-500 dark:text-gray-400">
        <span>Sno. #{index + 1}</span>
        <ChevronRight className="w-5 h-5 text-green-600" />
      </div>
    </div>
  );
};
